import { Brain, Heart, Lightbulb, TrendingUp } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function Insights() {
  const insights = [
    {
      title: "Stress Patterns",
      description: "You tend to feel more anxious in the evenings",
      trend: "increasing",
      icon: TrendingUp,
    },
    {
      title: "Coping Strategies",
      description: "Deep breathing exercises have been most effective",
      trend: "stable",
      icon: Heart,
    },
    {
      title: "Progress Tracking",
      description: "Mood improvements noted over the past week",
      trend: "improving",
      icon: Brain,
    },
  ];

  return (
    <div className="mx-auto w-full max-w-2xl">
      <div className="mb-6">
        <h2>Key Insights</h2>
        <p className="text-muted-foreground">
          Track your progress and understand patterns in your sales journey.
        </p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-primary">
            <Lightbulb className="size-5" />
            Key Insights
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {insights.map((insight, index) => (
            <div key={index} className="border-l-4 border-primary/30 pl-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="mb-1 flex items-center gap-2">
                    <insight.icon className="size-4 text-primary" />
                    <h4>{insight.title}</h4>
                  </div>
                  <p className="text-muted-foreground">{insight.description}</p>
                </div>
                <Badge
                  variant={
                    insight.trend === "improving" ? "default" : "secondary"
                  }
                  className="ml-2"
                >
                  {insight.trend}
                </Badge>
              </div>
            </div>
          ))}
          <Button
            variant="outline"
            className="mt-4 w-full border-primary/20 hover:border-primary/40 hover:bg-primary/5"
          >
            View Detailed Analysis
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
